import { render, staticRenderFns } from "./NavBarBom.vue?vue&type=template&id=1cfeb280&"
import script from "./NavBarBom.vue?vue&type=script&lang=js&"
export * from "./NavBarBom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports